<div class="d-flex overlay " *ngIf="isLoading | async">
    <div class="loading">Loading&#8230;</div>
  </div>